// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Comment-module--cds--assistive-text--b6045";
export var cdsHideFeedback = "Comment-module--cds--hide-feedback--c44f0";
export var cdsShowFeedback = "Comment-module--cds--show-feedback--aa79e";
export var cdsSkeleton = "Comment-module--cds--skeleton--06b0c";
export var cdsVisuallyHidden = "Comment-module--cds--visually-hidden--387c3";
export var container = "Comment-module--container--abe49";
export var fadeout = "Comment-module--fadeout--0ed65";
export var focused = "Comment-module--focused--c91a4";
export var textarea = "Comment-module--textarea--34b4c";